<template>
    <TitleComponent v-if="isMobile==true" :title="t('setup2')"></TitleComponent>
    <div class="address">
        <!-- <div >
            <div class="top ">
                <div @click="goBack()"><svg-icon icon-class="fanhui" /></div>
                <div>{{ $t('setup2') }}</div>
                <div @click="openModel()">{{ $t('number29') }}</div>
            </div>
        </div> -->
        <div v-if="isMobile==false">
            <div class="header aboutflex">
                <div class="header-title">{{ $t('number28') }}</div>
                <div class="header-but" @click="openModel()">{{ $t('number29') }}</div>
            </div>

        </div>
        <div class="addressList" v-if="isMobile==false">
            <div class="cart-none" v-if="addressAll.length === 0">
                <el-empty :description="t('setup11')">

                </el-empty>
            </div>
            <div class="addressItem" v-for="(item, i) in addressAll" :key="i">
                <div class="item">
                    <div>
                        <el-checkbox v-model="item.selected" @change="selectAddress(item.id)">
                        </el-checkbox>
                    </div>
                    <div class="Content">
                        <div class="nation" ><div class="Default" v-if="item.default == 1">{{ $t('number30') }}</div>{{ item.country }}-{{ item.province }}-{{ item.city }}</div>
                        <div class="text">{{ item.area }}</div>
                        <div class="mobile">{{ item.surname }}{{ item.name }} {{item.area_code}}{{ item.mobile }}
                        </div>
                    
                    </div>
                
                    <div class="Operation" > 
                        <img style="width: 30px;height: 30px;margin-bottom: 10px;" @click="getInfo(item.id)" src="../../../assets/images/edits.png" alt="" srcset="">
                        <img style="width: 30px;height: 30px;" @click="del(item.id)" src="../../../assets//images/del.png" alt="" srcset="">
                    </div>
                </div>
                <!-- <div class="Default" v-if="item.default == 1">{{ $t('number30') }}
                </div> -->
            </div>
        </div>
        <div class="phoneAddressList" v-else>
            <div class="cart-none" v-if="addressAll.length === 0">
                <el-empty :description="t('setup11')">

                </el-empty>
            </div>  
            <div class="addressItem" v-for="(item, i) in addressAll" :key="i">
                <div class="item">
                   
                    <div class="Content">
                        <div class="mobile">{{ item.surname }}{{ item.name }} {{item.area_code}}{{ item.mobile }}
                        </div>
                        <div class="nation ellipsis-2 " >{{ item.country }},{{ item.province }},{{ item.city }},{{ item.area }}</div>
                    </div>
                    <div class="Defaultbut aboutflex">
                        <div class="check HorizontalCenter" @click="selectAddress(item.id)">
                            <img style="width: 16px; width: 16px;" v-if="item.default == 1" src="../../../assets/images/check.png" alt="" srcset="">
                            <img style="width: 16px; width: 16px;" v-else src="../../../assets/images/nocheck.png" alt="" srcset="">
                            <div class="title" v-if="item.default == 1">{{ $t('number30') }}</div>
                        </div>
                        <div>
                            <img style="width: 18px;height: 17px;" @click="getInfo(item.id)" src="../../../assets/images/edit.png" alt="" srcset="">
                            <img style="width: 16px;height: 17px;margin-left: 25px;" @click="del(item.id)" src="../../../assets/images/dels.png" alt="" srcset="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="add HorizontalCenter" @click="openModel()">
                {{ $t('number29') }}
            </div>
        </div>
    </div>
    <div v-if="isMobile==false">
        <el-dialog v-model="dialogAddress" :title="modeltitle" width="800" :before-close="handleClose">
            <div style="padding:0 20px;">
                <addressView :id="infoId" @handleClose="handleClose" v-if="dialogAddress"></addressView>
            </div>
        </el-dialog>
    </div>
    <div v-else>
        <el-drawer v-model="dialogAddress" show-close :with-header="false" direction="btt" :before-close="handleClose"
        size="80%">
        <!-- <el-dialog v-model="dialogAddress" :title="modeltitle" width="340" :before-close="handleClose"> -->
            <div>
                <addressView :id="infoId" @handleClose="handleClose" v-if="dialogAddress"></addressView>
            </div>
        <!-- </el-dialog> -->
         </el-drawer>
    </div>
   
</template>
<script setup>
import TitleComponent from "@/components/TitleComponent/index.vue"
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const router = useRouter()
import { addressListAPI, setDefaultaddressAPI,delAddressAPI } from '@/apis/user'
const isMobile = ref(false);//false代表pc
onMounted(() => {
    addressList();
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})
const goBack = () => {
    router.go(-1);
}
const addressAll = ref([])
/**
 * 获取地址列表
 */
const addressList = async () => {
    const res = await addressListAPI()
    if (res.code == 0) {
        addressAll.value = res.data.list
        addressAll.value.forEach(address => {
            if (address.default == 1) {
                address.selected = true
            } else {
                address.selected = false
            }

        });
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
//设置默认地址
const selectAddress = async (id) => {

    const res = await setDefaultaddressAPI({ address_id: id })
    if (res.code == 0) {
        // 将所有地址的选中状态重置为未选中
        addressAll.value.forEach(address => {
            address.selected = false;
            if (address.id == id) {
                address.selected = true

            } else {
                address.selected = false
            }
        });
        addressList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }


}
const dialogAddress = ref(false)
const modeltitle = ref(t('number16'))
const openModel = () => {
    modeltitle.value = t('number16');
    dialogAddress.value = true
}
const infoId = ref()
//获取地址详情
const getInfo = async (id) => {
    modeltitle.value = t('number17')
    dialogAddress.value = true
    infoId.value = id
}
const del=async (id)=>{
    ElMessageBox.confirm(
        t('cart7'),
        {
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK',
            type: 'warning',
        }
    )
        .then(async () => {
            const res = await delAddressAPI({address_id:id})
            if (res.code == 0) {
                ElMessage({ type: 'success', message: t('number112')})
                addressList()
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: t('number113'),
            })
        })
   
}
const handleClose = () => {
    infoId.value=null
        dialogAddress.value = false
    addressList()
}
</script>
<style scoped lang="scss">
.address {
    padding: 0 20px;
    height: 100%;
    background-color: #fff;
    padding-bottom: 73px;
    border-radius: 8px;

    .header {
        // height: 66px;
        // border-bottom: 1px solid #f5f5f5;s
        padding: 19px 0px;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        font-size: 17px;
        .header-title{
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #11192D;
            line-height: 18px;
            text-align: left;
            font-style: normal;
        }
        .header-but{
            background: #FFFFFF;
            border-radius: 20px;
            border: 1px solid #E5E8EC;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #11192D;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            padding: 10px 30px;
        }



    }

    .addressList {
        // display: grid;
        // grid-template-columns: repeat(auto-fit, minmax(340px, 0fr));
        // grid-auto-rows: 90px;
        // grid-gap: 20px;
        // padding: 20px 0;

        .addressItem {
            position: relative;
            width: 100%;
            .item{
               
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 1px solid #f5f5f5;
            padding: 20px 20px;
            border-radius: 25px;
            margin-bottom: 15px;

            .Content {
                text-align: left;
                flex: 1;
                padding-left: 20px;
                // font-size: 14px;
                // line-height: 21px;
                // width: 210px;
                .Default{
                    padding: 2px 4px;
                    background: #FEF1EA;
border-radius: 2px;
                    font-family: MicrosoftYaHei;
                    font-size: 12px;
                    color: #FC3938;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
                .nation{
                    display: flex;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #888888;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                }
                .text {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #11192D;
                    line-height: 21px;
                    text-align: left;
                    font-style: normal;
                    margin-top: 5px;
                }
                .mobile{
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #333333;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                    margin-top: 5px;
                }

                .Contacts {
                    display: flex;


                }

            }
            
            .Operation {
                display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    align-items: center;

               
            }
        }
        // .Default {
        //     position: absolute;
            
        //     right: 23px;
        //     top: -7px;
        //             // margin-top: 15px;
        //             // margin-left: 10px;
        //             background-color: rgba(241, 133, 55, 0.1411764706);
        //             font-size: 12px;
        //             color: #e26237;
        //             width: 45px;
        //             display: flex;
        //             align-items: center;
        //             justify-content: center;
        //             border-radius: 37px;
        //             padding: 2px 0;
        //         }
        }
    }

}

@media (max-width: 768px) {
    .address {
        padding: 0 0px;
        // height: 100%;
        background-color: #f7f7f7;
        padding-bottom: 0px;
        height: 100%;
        .phoneAddressList{
            margin-top: 45px;
            background-color:#f7f7f7;
            padding: 15px 15px 56px 15px;
            .addressItem{
                background: #FFFFFF;
                box-shadow: 0px 4px 20px 6px rgba(237,237,237,0.75);
                border-radius: 8px;
                border: 1px solid #F3F6F8;
                margin-bottom: 15px;
                .item{
                    .Content{
                        padding: 20px 15px 15px 15px;
                        .mobile{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            line-height: 16px;
                            text-align: left;
                            font-style: normal;
                        }
                        .nation{
                            padding-top: 8px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            line-height: 20px;
                            text-align: left;
                            font-style: normal;
                        }
                    }
                    .Defaultbut{
                        padding: 20px 15px;
                        // display: flex;
                        .check{
                            // display: flex;
                            .title{
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 12px;
                                color: #FF4F00;
                                line-height: 14px;
                                text-align: left;
                                font-style: normal;
                                padding-left: 5px;
                            }
                        }
                    }
                }
            }
            .add{
                position: fixed;
    bottom: 6px;
                background: #FC3938;
                border-radius: 20px;
                border: 1px solid #FF4F00;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                height: 40px;
                width: calc(100% - 30px);
            }
        }
    }
}
</style>